import { render } from "./SelectorBobinaComponent.vue?vue&type=template&id=62121db6&scoped=true&class=margen"
import script from "./SelectorBobinaComponent.vue?vue&type=script&lang=js"
export * from "./SelectorBobinaComponent.vue?vue&type=script&lang=js"

import "./SelectorBobinaComponent.vue?vue&type=style&index=0&id=62121db6&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\eric.aparicio\\Documents\\REPOS\\ubiku.2023-master\\com.ubiku.ges.ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62121db6"]])

export default __exports__